import { render, staticRenderFns } from "./user_head.vue?vue&type=template&id=4053a94a&scoped=true"
import script from "./user_head.vue?vue&type=script&lang=js"
export * from "./user_head.vue?vue&type=script&lang=js"
import style0 from "./user_head.vue?vue&type=style&index=0&id=4053a94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053a94a",
  null
  
)

export default component.exports